import { render } from "./BaseIcon.atom.vue?vue&type=template&id=6836df54&bindings={\"iconName\":\"props\",\"icon\":\"setup\"}"
import script from "./BaseIcon.atom.vue?vue&type=script&lang=ts"
export * from "./BaseIcon.atom.vue?vue&type=script&lang=ts"
script.render = render

export default script